import React from "react";

/* Murphy wordmark – bold lowercase "murphy" with a lime accent dot,
   echoing the brand identity from murphy.no */
export default function MurphyLogo({ className = "", size = "md", showMark = true }) {
  const textSize = size === "sm" ? "text-lg" : size === "lg" ? "text-3xl" : "text-2xl";
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showMark && (
        <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-brand-ink">
          <span className="w-3 h-3 rounded-sm bg-brand-lime" />
        </span>
      )}
      <span className={`font-extrabold tracking-tight text-brand-ink lowercase ${textSize} leading-none`}>
        murphy<span className="text-brand-limeDark">.</span>
      </span>
    </div>
  );
}
